import React, { useEffect, useState, lazy } from 'react';
export const CTAButton = ({
  children,
  href = '#pricing',
  className = '',
  variant = 'primary'
}: {
  children: React.ReactNode;
  href?: string;
  className?: string;
  variant?: 'primary' | 'outline';
}) => {
  const handleClick = () => {
    if (typeof window !== 'undefined' && (window as any).fbq && href.includes('checkout')) {
      ;
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: 'Vitality 360 Master Kit',
        content_category: 'Health',
        currency: 'USD',
        value: 25
      });
    }
  };
  return <a href={href} onClick={handleClick} className={`inline-flex items-center justify-center px-8 py-4 rounded-lg font-bold uppercase transition-all duration-300 text-center cta-shadow cta-animated ${variant === 'primary' ? 'bg-familia-cyan text-familia-bg hover:bg-familia-coral/90' : 'border-2 border-familia-cyan text-familia-cyan hover:bg-familia-cyan/10'} ${className}`} data-id="element-205">
      {children}
    </a>;
};
export const Countdown = ({
  className = ''
}: {
  className?: string;
}) => {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 54,
    s: 1
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return {
          h: 23,
          m: 59,
          s: 59
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (n: number) => n.toString().padStart(2, '0');
  return <div className={`flex justify-center items-start gap-2 sm:gap-4 font-mono text-2xl sm:text-4xl md:text-6xl font-bold text-familia-cyan w-full ${className}`} data-id="element-206">
      <div className="flex flex-col items-center" data-id="element-207">
        <div className="bg-familia-card border border-familia-cyan/30 px-3 py-2 sm:p-3 rounded-lg min-w-[60px] sm:min-w-[80px] text-center" data-id="element-208">
          [{format(timeLeft.h)}]
        </div>
        <span className="text-[10px] sm:text-xs text-familia-gray mt-2 uppercase font-sans" data-id="element-209">
          hours
        </span>
      </div>
      <div className="pt-2 sm:pt-4" data-id="element-210">:</div>
      <div className="flex flex-col items-center" data-id="element-211">
        <div className="bg-familia-card border border-familia-cyan/30 px-3 py-2 sm:p-3 rounded-lg min-w-[60px] sm:min-w-[80px] text-center" data-id="element-212">
          [{format(timeLeft.m)}]
        </div>
        <span className="text-[10px] sm:text-xs text-familia-gray mt-2 uppercase font-sans" data-id="element-213">
          minutes
        </span>
      </div>
      <div className="pt-2 sm:pt-4" data-id="element-214">:</div>
      <div className="flex flex-col items-center" data-id="element-215">
        <div className="bg-familia-card border border-familia-cyan/30 px-3 py-2 sm:p-3 rounded-lg min-w-[60px] sm:min-w-[80px] text-center" data-id="element-216">
          [{format(timeLeft.s)}]
        </div>
        <span className="text-[10px] sm:text-xs text-familia-gray mt-2 uppercase font-sans" data-id="element-217">
          seconds
        </span>
      </div>
    </div>;
};
export const PriceCard = () => {
  const items = ['Module 1: Sharp Mind Workbook (150+ cognitive activities)', 'Module 2: Move with Confidence (Routines and fall prevention)', "Module 3: Expert Care Protocol (Alzheimer's, Parkinson's, Diabetes)", 'Module 4: Vitality 360 Health Tracker (Health logs 2026)', 'Module 5: The Empowered Caregiver Guide (Burnout prevention & organization)', 'VIP Module: 150+ at-home exercises (3 adaptation levels)', 'Bonus 1: Vital Nutrition 60+ (Recipes and weekly meal plan)', 'Bonus 2: Family Connection Kit (Reminiscence cards and family activities)', 'Bonus 3: Safe Home Checklist (142-item safety audit)', 'Large print throughout all materials', 'Clear illustrations for each activity', 'Printable trackers and logs', 'Evidence-based content updated 2026', '240+ pages of premium content'];
  return <div className="bg-familia-section border-2 border-familia-gold rounded-2xl p-6 sm:p-10 shadow-[0_0_30px_-12px_rgba(242,181,68,0.5)] sm:shadow-[0_0_50px_-12px_rgba(242,181,68,0.4)] max-w-2xl mx-auto relative overflow-hidden" data-id="element-218">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 bg-familia-gold text-familia-bg font-bold text-xs py-1 px-4 rounded-b-lg uppercase" data-id="element-219">
        ⭐ COMPLETE SYSTEM 2026
      </div>
      <div className="text-center mt-4 mb-8" data-id="element-220">
        <h3 className="text-2xl font-display font-bold mb-1" data-id="element-221">Vitality 360™</h3>
        <p className="text-familia-gray text-sm uppercase tracking-widest" data-id="element-222">
          Complete Senior Care Master Kit
        </p>
      </div>
      <div className="flex items-center gap-4 mb-8 bg-familia-card/60 p-4 rounded-xl border border-white/5" data-id="element-223">
        <img src="https://cdn.magicpatterns.com/uploads/wD6XHHXqEzi2b4vbyPnFv3/hf_20260528_015615_d7bdc0e4-f184-4423-868f-2fe77bd4c3a9-removebg-preview.png" alt="Vitality 360 Master Kit" width="96" height="96" loading="lazy" className="w-24 h-24 object-contain" data-id="element-224" />
        <div className="flex flex-col items-start" data-id="element-225">
          <span className="text-familia-red line-through text-lg mb-1" data-id="element-226">
            $79 USD
          </span>
          <span className="text-familia-cyan text-4xl font-bold" data-id="element-227">$25 USD</span>
        </div>
      </div>
      <div className="bg-[#F0F7FF] border border-[#00A1FF] rounded-xl p-4 mb-6 text-left" data-id="element-228">
        <h4 className="text-[#001E3C] font-bold text-sm mb-1 flex items-center gap-2" data-id="element-229">
          🌎 INTERNATIONAL PAYMENT
        </h4>
        <p className="text-[#003A70] text-xs leading-relaxed" data-id="element-230">
          <strong data-id="element-231">The product price is $25 USD.</strong> During checkout, the
          amount will be automatically converted to your local currency
          according to your country, payment provider and available payment
          method.{' '}
          <strong data-id="element-232">
            You will be able to review the final amount before confirming your
            payment.
          </strong>{' '}
          Purchase securely from anywhere in the world and receive instant
          digital access by email.
        </p>
      </div>
      <CTAButton href="#checkout" className="w-full text-lg py-5 mb-4" data-id="element-233">
        → YES — Give My Family the System They Deserve · $25 USD
      </CTAButton>
      <div className="mb-6 text-center" data-id="element-234">
        <div className="flex justify-center items-center gap-3 mb-2 opacity-80 grayscale hover:grayscale-0 transition-all duration-300" data-id="element-235">
          <span className="bg-white px-1.5 py-0.5 rounded text-[10px] font-bold text-blue-800 border border-gray-200" data-id="element-236">
            VISA
          </span>
          <span className="bg-white px-1.5 py-0.5 rounded text-[10px] font-bold text-red-600 border border-gray-200" data-id="element-237">
            MASTERCARD
          </span>
          <span className="bg-white px-1.5 py-0.5 rounded text-[10px] font-bold text-blue-500 border border-gray-200" data-id="element-238">
            AMEX
          </span>
          <span className="bg-white px-1.5 py-0.5 rounded text-[10px] font-bold text-purple-700 border border-gray-200" data-id="element-239">
            DISCOVER
          </span>
          <span className="bg-white px-1.5 py-0.5 rounded text-[10px] font-bold text-orange-600 border border-gray-200" data-id="element-240">
            PAYPAL
          </span>
        </div>
        <p className="text-familia-gray text-[10px] leading-tight" data-id="element-241">
          🔒 Secure encrypted checkout. <br data-id="element-242" />
          Instant digital access in less than 5 minutes.
        </p>
      </div>
      <div className="flex flex-wrap justify-center gap-4 text-[10px] sm:text-xs text-familia-gray mb-8" data-id="element-243">
        <span data-id="element-244">🔒 Secure payment</span>
        <span data-id="element-245">⚡ Instant access</span>
        <span data-id="element-246">🛡️ 30-day guarantee</span>
        <span data-id="element-247">🌍 Worldwide</span>
      </div>
      <div className="space-y-3 border-t border-white/10 pt-8" data-id="element-248">
        {items.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-249">
            <span className="text-familia-green text-lg" data-id="element-250">✅</span>
            <span className="text-sm sm:text-base font-medium" data-id="element-251">{item}</span>
          </div>)}
      </div>
      <p className="text-center text-familia-gray text-xs mt-8" data-id="element-252">
        One-time payment · No monthly subscription · Lifetime access
      </p>
    </div>;
};